<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h-outTabs'>
        <ejs-tab id='historyAlarmTab' ref='tabRef' :showCloseButton='true' heightAdjustMode='Auto' :removing='beforeRemoving' :selected='selectedTab'>
          <e-tabitems>
            <e-tabitem :header='tab.headerText' content='#historyTable' cssClass='h-tab-noClose'></e-tabitem>
            <e-tabitem :header='tab.headerTexts' content='#staticsChar'></e-tabitem>
          </e-tabitems>
        </ejs-tab>
        <div id='historyTable' class='h100vh-140'>
          <AlarmTableButton ref='alarmTableButton' @notice='notice' @keywords='changeKeywords'
            :refreshBtn='true' :exportBtn='true' :separatorLine='true' :showDetailBtn='true' :statisticsBtn='true' :filterBtn='true'  :keywordsInput='true'></AlarmTableButton>
          <AlarmTable :roleNe='roleNetList' ref='alarmTable'></AlarmTable>
        </div>
        <div id='staticsChar' class='h100vh-140' style='display: none;'>
          <StaticsChar ref='staticsCharRef' :roleNe='roleNetList' url='/lte/ems/fm/alarmhistory/getStatisticsInfo' :option='charOption'></StaticsChar>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import AlarmTableButton from '../../components/alarmconfig/currentAlarm/CurrentAlarmTableButton';
import AlarmTable from '../../components/alarmconfig/historyAlarm/HistoryAlarmTable';
import StaticsChar from '../../components/alarmconfig/historyAlarm/StatisticsChar';

export default {
  name: 'HistoryAlarmPage',
  components: {
    BasicLayout,
    AlarmTableButton,
    AlarmTable,
    StaticsChar
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.historyAlarm')}`
      },
      tab: {
        headerText: { text: this.$t('Alarm.historyAlarm') },
        headerTexts: { text: this.$t('Alarm.statistics') }
      },
      charOption: {
        charTitle: `${this.$t('Alarm.historyAlarm')} ${this.$t('Alarm.statistics')}`,
        allNumTitle: this.$t('Alarm.alarmNum')
      },
      roleNetMap: {},
      roleNetList: []
    };
  },
  methods: {
    changeKeywords(args) {
      this.$refs.alarmTable.queryConditions.keywords = args;
    },
    staticsTabFunc() {
      const tabObj = this.$refs.tabRef.ej2Instances;
      tabObj.hideTab(1, false);
      tabObj.select(1);
      this.$refs.staticsCharRef.getStatisData(true);
    },
    selectedTab(args) {
      if (args.selectedIndex === 1) {
        this.right.crumb = `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.historyAlarm')}/${this.$t('Alarm.statistics')}`;
      } else {
        this.right.crumb = `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.historyAlarm')}`;
      }
    },
    beforeRemoving(args) {
      if (args.removedIndex === 1) {
        args.cancel = true;
        this.$refs.tabRef.ej2Instances.hideTab(1, true);
      }
    },
    notice(type) {
      switch (type) {
        case 'refresh':
          this.$refs.alarmTable.queryConditions.conditions = '';
          this.$refs.alarmTable.page.pageNo = "1";
          this.$refs.alarmTable.getAlarmListData();
          break;
        case 'refreshTable':
          this.$refs.alarmTable.page.pageNo = "1";
          this.$refs.alarmTable.getAlarmListData();
          break;
        case 'conditions':
          this.$refs.alarmTable.conditionsStatus = true;
          this.$refs.alarmTable.getAlarmListData();
          break;
        case 'keywords':
          this.$refs.alarmTable.conditionsStatus = false;
          this.$refs.alarmTable.getAlarmListData();
          break;
        case 'export':
          this.$refs.alarmTable.exportAlarmListData();
          break;
        case 'showDetail':
          this.$refs.alarmTable.showDetail();
          break;
        case 'statistics':
          this.staticsTabFunc();
          break;
        case 'filter':
          this.$refs.alarmTable.filterFunc();
          break;
        default:
      }
    }
  },
  beforeMount() {
    const This = this;
    This.roleNetMap = {};
    This.roleNetList = [];
    this.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
      if (response && response.status === 200) {
        for (let i = 0; i < response.data.length; i++) {
          This.roleNetMap[response.data[i]] = 1;
          This.roleNetList.push(response.data[i]);
        }
      }
    });
  },
  mounted() {
    this.$refs.tabRef.ej2Instances.hideTab(1, true);
  }
};
</script>
